import React from 'react';
import { Controller } from 'react-hook-form';
import SelectProvince from '../../../components/form/SelectProvince';
import TextAreaInput from '../../../components/form/TextAreaInput';
import TextInput from '../../../components/form/TextInput';
import SelectCity from '../../../components/form/SelectCity';

const Location = ({ isEditable, form, loading }) => {
  const watchProvince = form.watch('province', false);

  const handleProvinceChange = (value, callback) => {
    callback(value);
    form.setValue('city', null);
  };
  return (
    <div className="row x-gap-100 y-gap-15 mt-20">
      <div className="col-6">
        <Controller
          control={form.control}
          name="province"
          render={({ field: { onChange, onBlur, value } }) => (
            <div className="mb-20">
              <SelectProvince
                disabled={!isEditable || loading}
                style="inline"
                onChange={(val) => handleProvinceChange(val, onChange)}
                onBlur={onBlur}
                type="text"
                label="Pilih Provinsi"
                value={value}
                isError={Boolean(form.formState.errors.province)}
                isSolid={true}
                errorMessage={
                  Boolean(form.formState.errors.province) && form.formState.errors.province.message
                }
              />
            </div>
          )}
        />
      </div>
      <div className="col-6">
        <Controller
          control={form.control}
          name="city"
          render={({ field: { onChange, onBlur, value } }) => (
            <div className="mb-20">
              <SelectCity
                disabled={!isEditable || loading}
                style="inline"
                onChange={onChange}
                onBlur={onBlur}
                type="text"
                label="Pilih Kota"
                isDependant={true}
                province_id={watchProvince ? watchProvince.value : null}
                value={value}
                isError={Boolean(form.formState.errors.city)}
                isSolid={true}
                errorMessage={
                  Boolean(form.formState.errors.city) && form.formState.errors.city.message
                }
              />
            </div>
          )}
        />
      </div>
      <div className="col-12">
        <Controller
          control={form.control}
          name="site_address"
          render={({ field: { onChange, onBlur, value } }) => (
            <TextAreaInput
              disabled={loading || !isEditable}
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              type="text"
              isRequired={true}
              label="Alamat Site"
              isError={Boolean(form.formState.errors.site_address)}
              errorMessage={
                Boolean(form.formState.errors.site_address) &&
                form.formState.errors.site_address.message
              }
            />
          )}
        />
      </div>
      <div className="col-6">
        <Controller
          control={form.control}
          name="lat"
          render={({ field: { onChange, onBlur, value } }) => (
            <TextInput
              disabled={loading || !isEditable}
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              type="number"
              isRequired={true}
              label="Latitude"
              isError={Boolean(form.formState.errors.lat)}
              errorMessage={Boolean(form.formState.errors.lat) && form.formState.errors.lat.message}
            />
          )}
        />
      </div>
      <div className="col-6">
        <Controller
          control={form.control}
          name="lng"
          render={({ field: { onChange, onBlur, value } }) => (
            <TextInput
              disabled={loading || !isEditable}
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              type="number"
              isRequired={true}
              label="Longitude"
              isError={Boolean(form.formState.errors.lng)}
              errorMessage={Boolean(form.formState.errors.lng) && form.formState.errors.lng.message}
            />
          )}
        />
      </div>
    </div>
  );
};

export default Location;
